var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.faces),function(f,i){return [_c('div',{key:i,style:(_vm.boxStyle(f))}),_vm._v(" "),_c('v-layout',{staticClass:"ma-0",style:(_vm.labelStyle(f)),attrs:{"row":"","justify-center":""}},[(f.Name)?_c('v-chip',{staticClass:"elevation-3",attrs:{"dark":""}},[_vm._v(_vm._s(f.Name))]):_vm._e()],1)]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b18d960","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cast/FacesDetection.vue
// module id = null
// module chunks = 